module.exports = __webpack_public_path__ + "static/media/bee.170ae027.png";